var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-toggle-list"},_vm._l((_vm.list),function(data,index){return _c('m-toggle-list-item',{key:("faq_" + (data.id)),attrs:{"data":data,"no":index + 1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }